import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

import {HEADERS, URL_API} from "../constante";
import {AppService} from "../app.service";
import {Recurso} from "./recurso";
import {Utils} from '../shared/utils';

@Injectable()
export class RecursoService extends AppService {
	
	documentoUrl = URL_API + '/recurso';

    pedirRecurso(dados): Promise<Response> {
        return this.http
            .post(this.documentoUrl + '/pedir', JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
	
	encaminharRecurso(trabalhoId: number, recursistaId: number): Promise<Response> {
		return this.http
            .get(this.documentoUrl + '/' + trabalhoId + '/' + recursistaId, {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
	}
	
	retornarRecurso(trabalhoId: number): Promise<Recurso> {
		return this.http
            .get(this.documentoUrl + '/' + trabalhoId, {headers: HEADERS})
            .toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
	}
	
	avaliarRecurso(dados): Promise<Response> {
        return this.http
            .post(this.documentoUrl + '/avaliar', JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
}


// WEBPACK FOOTER //
// ./src/app/pedir-recurso/recurso.service.ts